import {
  Lit3formBlock,
  html,
  unsafeHTML,
  ifDefined,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';

import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

import '@Helpers/vimeo-video';

export class Tyler extends Lit3formBlock {
  static get characterName() {
    return 'tyler';
  }

  static get characterProperties() {
    return {
      header: { type: String },
      description: { type: String },
      cta: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid tyler-layout">
          ${this.subHeaderHTML} ${this.primaryTextHTML} ${this.descriptionHTML}
          ${this.ctaHTML}
          ${this.videoId
            ? html`
                <div class="video media">
                  <vimeo-video
                    videoid="${this.videoId}"
                    autoload
                    autoplay
                  ></vimeo-video>
                </div>
              `
            : html`
                <div class="image media">
                  <a
                    href=${ifDefined(
                      this.hasCta ? this.content.cta.url : undefined
                    )}
                  >
                    <img src="${this.imageUrl}" />
                  </a>
                </div>
              `}
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get subHeaderHTML() {
    return this.subHeaderText
      ? html`
          <p class="subheader">${unsafeHTML(this.subHeaderText)}</p>
        `
      : ``;
  }

  get primaryTextHTML() {
    return this.primaryText
      ? html`
          <div class="primary-text details-row">
            <h2>${unsafeHTML(this.primaryText)}</h2>
          </div>
        `
      : ``;
  }

  get descriptionHTML() {
    return this.descriptionText
      ? html`
          <p class="description details-row">
            ${unsafeHTML(this.descriptionText)}
          </p>
        `
      : ``;
  }

  get ctaHTML() {
    return this.hasCta
      ? html`
          <cta-button
            class="cta-btn"
            cta-data=${this.ctaInfo}
            cta-type="primary"
            .ctaAnalyticsData=${analyticsCtaDataObject(
              this.ctaInfo,
              this.primaryText
            )}
          ></cta-button>
        `
      : ``;
  }

  get ctaInfo() {
    const cta = this.content.cta || {};
    // external links need to open in a new tab
    if (!cta.url.includes('3-form')) {
      cta.target = '_blank';
    }
    return JSON.stringify(this.content.cta);
  }

  get hasCta() {
    return this.content.cta && !!this.content.cta.text;
  }

  get primaryText() {
    return this.withLineBreaks(this.content.primary_text) || '';
  }

  get subHeaderText() {
    return this.withLineBreaks(this.content.sub_header) || '';
  }

  get descriptionText() {
    return this.withLineBreaks(this.content.description) || '';
  }

  get videoId() {
    if (!!this.content.video_url && this.content.video_url.includes('vimeo')) {
      return this.content.video_url.match(
        /^https?:\/\/(?:.*?)\.?(vimeo)\.com\/(\d+).*$/
      )[2];
    } else {
      return '';
    }
  }

  get imageUrl() {
    return !!this.content.image
      ? this.imagebossUrl(this.content.image.src, null, 1500)
      : '';
  }
}
Tyler.defineElement();
